import { DiseaseTypes, ProtectionTypes } from '@/common/variables';

export const needs = {
  [ProtectionTypes.family]: {
    type: ProtectionTypes.family,
    label: 'Family protection',

    isSelected: false,
    isAgree: false,

    isTakeCare: false,
    isReplacementAsked: false,
    replacement: false,
    isReplaceIncome: false,
    isAnyChildren: false,

    isChildrenCountAsked: false,
    childrenCount: null,

    isAgeOfChildAsked: false,
    childrenAge: null,

    isCollegeExpensesAsked: false,
    collegeExpenses: false,
  },
  [ProtectionTypes.mortgage]: {
    type: ProtectionTypes.mortgage,
    label: 'Mortgage protection',

    isSelected: false,
    isAgree: false,

    isHomePayoffAsked: false,
    amount: null,
    isMortgageYearsLeftAsked: false,
    yearsLeft: null,
  },
  [ProtectionTypes.debt]: {
    type: ProtectionTypes.debt,
    label: 'Debt protection',

    isSelected: false,
    isAgree: false,

    isDebtsAmountAsked: false,
    amount: null,
  },
  [ProtectionTypes.finalExpenses]: {
    type: ProtectionTypes.finalExpenses,
    label: 'Final Expenses',

    isSelected: false,
    isAgree: false,
    target: null,
    isAgreeWithAmount: false,

    name: null,
    term: 'fex',
    termLabel: 'Final Expenses',
    amount: null,
  },
};

export const disease = {
  [DiseaseTypes.cancer]: {
    isSelected: false,
    isSquamousCell: false,
  },
  [DiseaseTypes.heartAttack]: {
    isSelected: false,
    bloodThinner: null,
    treatedTimeframe: null,
  },
  [DiseaseTypes.heartDisease]: {
    isSelected: false,
    bloodThinner: null,
    treatedTimeframe: null,
  },
  [DiseaseTypes.stroke]: {
    isSelected: false,
    tia: false,
    paralysis: false,
  },
  [DiseaseTypes.diabetes]: {
    isSelected: false,
    treatmentType: null,
    a1c: null,
    complications: false,
  },
  [DiseaseTypes.asthma]: {
    isSelected: false,
    hospitalizations: false,
  },
  [DiseaseTypes.sleepApnea]: {
    isSelected: false,
    hospitalizations: false,
  },
  [DiseaseTypes.copd]: {
    isSelected: false,
    oxygenPrescribed: false,
  },
  [DiseaseTypes.emphysema]: {
    isSelected: false,
    oxygenPrescribed: false,
  },
  [DiseaseTypes.depression]: {
    isSelected: false,
    hospitalizations: false,
  },
  [DiseaseTypes.bloodPressure]: {
    isSelected: false,
    medsCount: null,
  },
  [DiseaseTypes.cholesterol]: {
    isSelected: false,
    medsCount: null,
  },
  [DiseaseTypes.chronicPain]: {
    isSelected: false,
    hospitalizations: false,
  },
};
